/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from 'prop-types';

import ReactDOM from 'react-dom';

import * as EditableListUtil from 'notebook/mediocre/selection/text/EditableListUtil';

export default {
  propTypes: {
    metadataForRestore: PropTypes.object,
  },

  clearSelection() {
    EditableListUtil.clearSelection(this.setSelection);
  },

  UNSAFE_componentWillMount() {
    this.clearSelection();
  },

  setSelection(selection) {
    // Save the desired selection, to be set on component update.
    this.selection = selection;
  },

  componentDidMount() {
    const rootNode = ReactDOM.findDOMNode(this);
    EditableListUtil.editableListDidMount(rootNode, this.props, this.setSelection);
  },

  componentDidUpdate(prevProps, prevState) {
    const rootNode = ReactDOM.findDOMNode(this);
    EditableListUtil.editableListDidUpdate(
      rootNode,
      prevProps,
      this.props,
      this.selection,
      this.setSelection
    );
  },
};
